// D:\directiveai-react\frontend\src\components\home\HomeInput\styles\AppStyle.js
import React from 'react';
import AppLayout from '../layouts/AppLayout';

const AppStyle = {
  getContainerStyles: (theme) => {
    // Usar background transparente si es modo wallpaper
    const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

    if (isWallpaperMode) {
      return { backgroundColor: 'transparent' };
    }

    return {
      backgroundColor: theme.palette.mode === 'dark' ? '#000000' : '#FFFFFF',
    };
  },

  getTextFieldStyles: () => ({}),
  
  getPromptCardStyles: (theme) => ({
    borderRadius: '8px',
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.mode === 'dark' ? '#333333' : '#E0E0E0'}`,
  }),
  
  getStylePreviewConfig: (theme) => {
    const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

    return {
      backgroundColor: theme.palette.mode === 'dark' ? '#000000' : '#FFFFFF',
      borderRadius: '8px',
      inputStyle: {
        borderRadius: '8px',
        backgroundColor: isWallpaperMode
          ? 'rgba(128, 128, 128, 0.3)'
          : (theme.palette.mode === 'dark' ? '#1C1C1E' : '#F2F2F7'),
        backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        border: `1px solid ${theme.palette.mode === 'dark' ? '#333333' : '#E0E0E0'}`,
      },
      cardStyle: {
        borderRadius: '8px',
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.mode === 'dark' ? '#333333' : '#E0E0E0'}`,
      }
    };
  },
  
  // Renderizar el layout correspondiente y pasar cualquier prop recibida, incluyendo la función de traducción
  renderLayout: (props) => <AppLayout {...props} />
};

export default AppStyle;